// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { alpha } from '@mui/material/styles';

const styles = (theme: any, showMapview?: boolean) => ({
  // AUT-6432: the Figma folder card - fixed 80px tall, 12px corners, a hairline border and
  // the shared card shadow. The border is always present so the drag-over highlight below
  // only recolours it, rather than adding width and nudging the row.
  mainContiner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '80px',
    padding: '15px 20px',
    cursor: 'pointer',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.borderGrey}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '2px 6px 4px rgba(0,0,0,0.1)',
    '& .MuiFab-root': {
      display: 'none',
    },
    '&:hover': {
      '& .MuiFab-root': {
        display: 'flex',
      },
    },
    '& .MuiFab-root.showFab': {
      display: 'flex',
    },
    // Phones and tablets have no hover to reveal the menu: it is always shown below tablet width, and on a touch screen
    // at any width (a tablet held landscape); a desktop with a mouse keeps the hover
    [theme.breakpoints.down('md')]: {
      '& .MuiFab-root': {
        display: 'flex',
      },
    },
    '@media (hover: none)': {
      '& .MuiFab-root': {
        display: 'flex',
      },
    },
    ...(showMapview && {
      margin: theme.spacing(1, 0),
    }),
    position: 'relative',
  },
  deleteBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.7)',
    backdropFilter: 'blur(20px)',
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1rem',
  },
  deleteDialogBox: {
    minWidth: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  deleteDialogText: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    textTransform: 'none',
    fontSize: '1rem',
  },
  deleteDialogActions: {
    display: 'flex',
    gap: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  deleteCancelBtn: {
    minWidth: 100,
  },
  deleteConfirmBtn: {
    minWidth: 100,
  },
  folderItemContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  folderIconContainer: {
    marginRight: theme.spacing(1),
    color: '#1C364B',
    borderRadius: '50%',
    backgroundColor: '#E5EAEE',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  folderName: {
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '0.6857px',
    color: theme.palette.text.primary,
  },
  projectCount: {
    marginTop: theme.spacing(0.5),
    color: '#797979',
    fontSize: '12px',
    letterSpacing: '0.5143px',
  },
  folderDetails: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
  moreIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px !important',
    width: '36px !important',
    borderRadius: '50%',
    padding: theme.spacing(1, 2),
    backgroundColor: '#F0F0F5',
    boxShadow: 'none',
    zIndex: 100,
  },
  menuList: {
    minWidth: '150px',
  },
  fontWeight: {
    fontWeight: 300,
  },
  folderListItemPopper: {
    zIndex: 9999,
    left: '-5rem !important',
    '& .MuiPaper-root': {
      borderTopRightRadius: '20px',
      boxShadow: '0px 2px 12px 0px rgba(0,0,0,0.1)',
      '& .MuiButtonBase-root.MuiMenuItem-root:hover': {
        color: theme.palette.primary.main,
        fontWeight: 400,
      },
    },
  },
  buttonProgress: {
    color: '#777777',
  },
  folderNameText: {
    textAlign: 'start',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '233px',
    width: '100%',
    display: 'block',
  },
  // The slot a dragged folder would land in: its in-flow card, emptied and outlined
  dropSlot: {
    border: `1px dashed ${theme.palette.primary.main}`,
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
    boxShadow: 'none',
    '& > *': {
      opacity: 0,
    },
  },
  // The picked-up card that follows the pointer (rendered by the drag overlay)
  dragPreview: {
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: '0px 8px 16px 0px #00000029',
    cursor: 'grabbing',
  },
  dragPreviewHandle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '32px',
    color: theme.palette.text.primary,
  },
  activeDroppableHover: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
});

export default styles;
